import { put, select } from "redux-saga/effects"
import { attemptReconnectAction } from "../attemptReconnect/action"
import { selectRegisterer, selectUAState } from "../../../state/userAgent/userAgentSlice"

export function* onDisconnectSaga({ payload: error }) {
    const registerer = yield select(selectRegisterer)
    const uaState = yield select(selectUAState)
    console.log('onDisconnect unRegister error:', error);
    console.log('onDisconnect uaState:', uaState, Date.now());

    if (registerer && uaState === 'registered') {
        console.log('Checking in onDisconnect', Date.now())
        try {
            yield registerer.unregister();
        } catch (e) {
            console.error(e)
        }
        if (error) {
            console.log('We hit attemptReconnect from onDisconnect', Date.now())
            yield put(attemptReconnectAction());
        }
    }


}